/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    REMOVE_CONTACT_HEADER_ICON
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Removed the faUser icon from the contact info header to match the latest 
 * Figma design requirements.
 *
 * File Size Check:
 * - Current: ~70 lines
 * - Limit: 200 lines
 * - Decision: Proceed (minor deletion)
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    REVIEW_USER_CONTACT_COMP
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Extracted icon-based contact info component for use in multiple review forms.
 * Matches Figma design with circular magenta backgrounds and specific icons.
 *
 * File Size Check:
 * - Current: ~70 lines
 * - Limit: 200 lines
 * - Decision: New component creation (under limit)
 *
 * Related Screens / Modules:
 * - client/src/components/setup/ReviewUserForm.tsx
 * - client/src/components/setup/ReviewProfileForm.tsx
 */
import React from "react";
import { Card } from "react-bootstrap";
import type { User } from "../../../../interfaces/User";

interface ReviewUserContactProps {
  profile: Partial<User> | null;
}

export const ReviewUserContact: React.FC<ReviewUserContactProps> = ({ profile }) => {
  // [2025-12-29] Icon-based contact layout matching Figma
  return (
    <Card className="review-card review-contact-card mb-3" style={{ width: "100%", maxWidth: "100%" }}>
      <Card.Body>
        <div className="review-contact-header d-flex align-items-center justify-content-between mb-3">
          <h6 className="review-contact-title mb-0">Contact info</h6>
        </div>

        <div className="review-contact-icon-list">
          {/* Email row */}
          {profile?.email && (
            <div className="review-contact-icon-row">
              <div className="review-contact-icon-bg">
                <img 
                  src="/assets/envelop.svg" 
                  alt="" 
                  className="review-contact-icon"
                  aria-hidden="true"
                />
              </div>
              <span className="review-contact-text">{profile.email}</span>
            </div>
          )}

          {/* Phone row */}
          {profile?.tel && (
            <div className="review-contact-icon-row">
              <div className="review-contact-icon-bg">
                <img 
                  src="/assets/phone.svg" 
                  alt="" 
                  className="review-contact-icon"
                  aria-hidden="true"
                />
              </div>
              <span className="review-contact-text">{profile.tel}</span>
            </div>
          )}

          {/* Address row - SINGLE LINE */}
          {(profile?.userCity || profile?.userState || profile?.userCountry) && (
            <div className="review-contact-icon-row">
              <div className="review-contact-icon-bg">
                <img 
                  src="/assets/address.svg" 
                  alt="" 
                  className="review-contact-icon"
                  aria-hidden="true"
                  style={{ color: "var(--color-black)" }}
                />
              </div>
              <span className="review-contact-text">
                {[
                  profile?.userCity,
                  profile?.userState,
                  profile?.userCountry
                ]
                  .filter(Boolean)
                  .join(", ")}
              </span>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};
